import React from 'react';
import { Apify } from '../Apify';
import { connect } from 'react-redux';
import store from '../store';
import { Button, Col, Container, Row } from 'reactstrap';
import { GameCard } from '../c/ChartCard';
import { PublicGames, QuotesFromPeople } from '../c/Game';
import XTab from '../c/XTab';
import { T } from '../traks';
import { BlessLink } from '../routes';
import { site_base, site_name } from '../Site';
import InspirationCards from '../c/Inspiration';
import DynamicBiatheElems from '../c/DynamicBiatheElems';
import { InfoToolTip } from '../c/InfoToolTip';

const game_is_ongoing = (game) => (game.EndTime - (new Date()).getTime()/1000) > 0; // XXX WRONG

const PromoNotLoggedIn = () => {
	return (
		<div className="ad_frontpage_top_blop">
                        <Container className="py-4">
                                <Row>
                                <Col xs="12" md="6" className="pt-0 pr-md-5">
                                        <div className="ad_top_games_heading pb-3"><T>One investment game,<br />many possibilities</T></div>
                                        <div className="ad_top_games_subheading pb-3">
						<T>
						Would you like to play with your friends and compete for the title of
						best investor? Do you want to understand finances in a playful way at
						school? Are you looking for a user-friendly platform to track your stock
						portfolios and learn to trade while having fun? Or would you like to
						compete against our community in our games and win cool prizes?
						Then {site_name} is for you.
						</T>
					</div>
                                        <div className="py-4 text-center text-md-left">
                                                <BlessLink><Button href="/new_game" className="ad_new_game_button px-md-4 py-3">
                                                        <span className="ad_first_game_btn_text px-5">
                                                                <T>Start your first game</T>
                                                        </span>
                                                </Button></BlessLink>
                                        </div>
                                </Col>
                                <Col xs="12" md="6" className="text-center pt-md-4 pl-md-5 pr-md-0">
                                        <div className="d-none d-md-inline-block">
                                                <img alt="quote" className="ad_top_games_img"
						src="https://static.aktiedysten.dk/gfx/trophy-cup-games-page-0.svg" />
                                        </div>
                                </Col>
                                </Row>
                        </Container>
		</div>
	);
}

const NoPersonalGames = (props) => {
	return (
		<Col xs="12">
			<div className="mt-4">
				<BlessLink>
					<Button className="ml-auto mb-auto ad_new_game_home_button px-4 py-2" href="/new_game">
						<T>Start a game</T>
					</Button>
				</BlessLink>
			</div>
		</Col>
	);
};

const AvailableKeys = Apify("/a/my_keys")
    .with_response_prop("my_keys")
    .wrap((props) => {
		const premiumKeys = props.my_keys.AvailablePremiumKeys;
		const freeKeys = props.my_keys.AvailableFreeKeys;

        return (
			<React.Fragment>
			<span className='font-xlarge mt-2'>
				<img className='mr-2' src='https://static.aktiedysten.dk/gfx/user-icon-green-2023-0.svg'/>
                <strong className='bold'>{freeKeys}</strong><T> free invitations remaining</T>
            </span>
            <span className='font-xlarge mt-2'>
				<img className='mr-2' src='https://static.aktiedysten.dk/gfx/user-icon-green-2023-0.svg'/>
                <strong className='bold'>{premiumKeys}</strong><T> premium invitations remaining</T>
				<InfoToolTip 
					title={<T>Premium invitations</T>}
					tooltipText={<T>An invitation is not personal. That means that when one of your games is finished and you are still an active premium user, you can use the invitation again for your next game.</T>}
					position="right"
					link={"/premium"}
				/>
            </span>
			</React.Fragment>
        )
    })

const LoadAndDisplayYourGames = Apify("/a/my_games")
	.with_response_prop("my_games")
.wrap((props) => {
	if (!props.my_games || props.my_games.length === 0) return <NoPersonalGames/>
	var game_cards = [];

	var n_ongoing = 0;
	var n_ended = 0;
	const right_now = (new Date()).getTime();

	const show_ongoing = props.xtab_index === 0;
	var best_chart_range = "3m";

	for (const game of props.my_games) {
		const game_run_time = right_now - game.StartTime * 1000;
		if(game_run_time < 14*60*60*24*1000) {
			best_chart_range = "7d";
		}
		if (game_is_ongoing(game)) {
			n_ongoing++;
			if (!show_ongoing) continue;
		} else {
			n_ended++;
			if (show_ongoing) continue;
		}
		const is_active = (game.State === "started" && game.PortfolioId === props.active_game_portfolio_id);
		game_cards.push(
			<Col key={game.Id} md="4" className="p-3">
				<GameCard is_active={is_active} range={best_chart_range} key={game.Id} game_id={game.Id} portfolio_id={game.PortfolioId} user_id={props.me.Id}/>
			</Col>
		);
	}

	const tabs = [<span><T>Ongoing</T> ({n_ongoing})</span>, <span><T>Ended</T> ({n_ended})</span>]
	const on_select = (i) => {
		store.dispatch_value("home_games_xtab_index", i);
	};

	return (
		<Container fluid className="pt-4">
			<Row>
				<Col className="pt-4" md="12">
					<div className="d-flex">
						<div className="d-flex flex-column pb-3" id="choose_a_game">
                            <b className='ad_150pct'><T>Your games</T></b>
                            {props.me && (
                                <AvailableKeys />
                            )}
                        </div>
						<BlessLink><Button className="ml-auto mb-auto ad_new_game_button px-4 py-2" href="/new_game"><T>New game</T></Button></BlessLink>
					</div>
					<XTab row_classes="pb-2" selected={props.xtab_index} onSelect={on_select} tabs={tabs}/>
				</Col>
				<Container fluid className="">
					<Row className="pt-3">
						{game_cards}
					</Row>
					<div>
                       {(
                        (props.xtab_index === 0 && n_ongoing !== 0) ||
                        (props.xtab_index === 1 && n_ended !== 0)
                        ) && (
                        <div className="ad_game_page_owngamesbox px-4 pt-5" />
                        )}
					</div>
				</Container>
			</Row>
		</Container>
	)
});

const GamesPageElements = connect(
	(state) => ({
		me: state.me,
		xtab_index: state.home_games_xtab_index,
		active_game_portfolio_id: state.LastGamePortfolioIdVisited || 0,
	})
)((props) => {
	if (!props.me) {
		return (
			<React.Fragment>
				<PromoNotLoggedIn/>
				<Container>
					<PublicGames show_placeholder_if_empty={false}/>
				</Container>
				<Container fluid className="bg-white">
					<Container>
						<QuotesFromPeople />
					</Container>
				</Container>
			</React.Fragment>
		);
	} else {
		return (
			<React.Fragment>
				<Container className="pb-5">
					<Row className="pt-4 pb-2">
						<LoadAndDisplayYourGames {...props}/>
						<div className="p-4" />
						<PublicGames show_placeholder_if_empty={false}/>
						{(IS_AKTIEDYSTEN_DK || IS_AKTIEKAMPEN_SE) &&
						<Container>
							<DynamicBiatheElems />
						</Container>}
					</Row>
				</Container>
				{(IS_AKTIEDYSTEN_DK || IS_AKTIEKAMPEN_SE) &&
				<Container className="pb-5">
					<InspirationCards />
				</Container>}
			</React.Fragment>
		);
	}
});


const Games = (props) => {
	return <GamesPageElements />
};

export default Games



// WEBPACK FOOTER //
// ./src/p/Games.js